import {
  Swiper, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.text-card-slider__swiper';

let lastInteractionType = 'mouse';
document.addEventListener('mousedown', () => { lastInteractionType = 'mouse'; });
document.addEventListener('touchstart', () => { lastInteractionType = 'touch'; }, { passive: true });
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    lastInteractionType = 'keyboard';
  }
});

function getMaxHeightSlider(element) {
  const slider = element;
  let maxHeight = 0;

  slider.el.style.height = 'auto';
  slider.updateSize();

  slider.slides.forEach((slide) => {
    const slideHeight = slide.offsetHeight;
    if (slideHeight > maxHeight) {
      maxHeight = slideHeight;
    }
  });

  maxHeight += 108;

  slider.el.style.height = `${maxHeight}px`;
  slider.updateSize();

  slider.update();
}

function handlerLock(element) {
  const slider = element;
  const wrap = slider.el.querySelector('.text-card-slider__wrapper');

  if (!slider.isLocked) {
    slider.params.centerInsufficientSlides = false;
    if (!wrap.classList.contains('text-card-slider__wrapper--cursor')) {
      wrap.classList.add('text-card-slider__wrapper--cursor');
    }

    if (window.innerWidth < breakpoints.md) {
      slider.params.slidesOffsetBefore = 0;
      slider.params.slidesOffsetAfter = 0;
    } else if (window.innerWidth >= breakpoints.md && window.innerWidth < breakpoints.lg) {
      slider.params.slidesOffsetBefore = 40;
      slider.params.slidesOffsetAfter = 40;
    } else if (window.innerWidth >= breakpoints.lg) {
      slider.params.slidesOffsetBefore = 120;
      slider.params.slidesOffsetAfter = 120;
    }
  } else {
    if (wrap.classList.contains('text-card-slider__wrapper--cursor')) {
      wrap.classList.remove('text-card-slider__wrapper--cursor');
    }

    slider.params.centerInsufficientSlides = true;
    slider.params.slidesOffsetBefore = 0;
  }

  slider.update();
}

function addEventsToSlide(slider) {
  slider.slides.forEach((slide, index) => {
    slide.addEventListener('focusin', () => {
      if (lastInteractionType === 'keyboard') {
        slider.slideTo(index, 0, false);
      }
    });
  });
}

function initTCSlider(container) {
  const nextBtnElement = container.querySelector('.text-card-slider__next');
  const prevBtnElement = container.querySelector('.text-card-slider__prev');
  let isNavClick = false;

  nextBtnElement.addEventListener('click', () => {
    isNavClick = true;
  });
  prevBtnElement.addEventListener('click', () => {
    isNavClick = true;
  });

  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 24,
    threshold: 10,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 'auto',
      },
      1200: {
        slidesPerView: 'auto',
      },
    },
    modules: [Navigation],
    navigation: {
      nextEl: '.text-card-slider__next',
      prevEl: '.text-card-slider__prev',
      disabledClass: 'c-arrow--disabled',
      lockClass: 'text-card-slider__navigation--lock',
    },
    on: {
      resize() {
        getMaxHeightSlider(this);
        handlerLock(this);
      },
      init() {
        getMaxHeightSlider(this);
        addEventsToSlide(this);
        handlerLock(this);
      },
      reachEnd() {
        if (isNavClick) {
          setTimeout(() => {
            prevBtnElement.focus({ preventScroll: true });
          }, 0);
          isNavClick = false;
        }
      },
      reachBeginning() {
        if (isNavClick) {
          setTimeout(() => {
            nextBtnElement.focus({ preventScroll: true });
          }, 0);
          isNavClick = false;
        }
      },
    },
  });
}

function detectBrowser() {
  const { userAgent } = navigator;
  let eventName = 'DOMContentLoaded';

  if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    eventName = 'load';
  }

  return eventName;
}

function initBlock() {
  const eventName = detectBrowser();

  window.addEventListener(eventName, () => {
    const initAllSliders = () => {
      const textCardSliderAll = document.querySelectorAll(swiperContainerClass);
      textCardSliderAll.forEach((el) => {
        initTCSlider(el);
      });
    };

    if (window.acf) {
      window.acf.addAction('render_block_preview/type=azds/text-card-slider', () => {
        initAllSliders();
      });
    } else {
      initAllSliders();
    }
  });
}

initBlock();
